import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import React from 'react';
import { Card, Cards } from '../../Grid';
import { SkeletonSquare } from '../../Skeleton';
import { productsGridBreakpoints } from '../grid';
import { ContentProductCard } from '../ContentProductCard';
export var ContentProductsGrid = function ContentProductsGrid(_ref) {
  var onFollow = _ref.onFollow,
    subscriptions = _ref.subscriptions,
    onAction = _ref.onAction,
    fetching = _ref.fetching,
    products = _ref.products,
    variant = _ref.variant,
    justify = _ref.justify,
    fixedWidth = _ref.fixedWidth,
    _ref$context = _ref.context,
    context = _ref$context === void 0 ? [] : _ref$context,
    _ref$withSPA = _ref.withSPA,
    withSPA = _ref$withSPA === void 0 ? false : _ref$withSPA,
    _ref$distributorsWhit = _ref.distributorsWhiteList,
    distributorsWhiteList = _ref$distributorsWhit === void 0 ? [] : _ref$distributorsWhit;
  return React.createElement("div", null, React.createElement(Cards, {
    breakpoints: productsGridBreakpoints,
    justify: justify
  }, products.length ? React.createElement(React.Fragment, null, products.map(function (product, index) {
    return React.createElement(Card, {
      key: "card-".concat(index)
    }, React.createElement(ContentProductCard, {
      distributorsWhiteList: distributorsWhiteList,
      withSPA: withSPA,
      onAction: onAction,
      product: product,
      position: index,
      variant: variant,
      onFollow: onFollow,
      following: (subscriptions || []).includes(product.entity.id),
      context: context,
      fixedWidth: fixedWidth
    }));
  })) : null, fetching ? React.createElement(React.Fragment, null, [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map(function (placeholderId) {
    return React.createElement(Card, {
      key: placeholderId
    }, React.createElement(SkeletonSquare, null));
  })) : null));
};